import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://0be300c54be27c37465d2d0125f92d0c@o4509952885915648.ingest.us.sentry.io/4509952887160832",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  enableLogs: true,
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
